import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import SessionContext from "SessionContext";
import { DisplayChannelOptions } from "./suppress-invoice-new-form";
import ConfirmSuccess from "../core/ui/confirm-success";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import UnsavedChanges from "partials/unsaved-changes";

function SuppressInvoiceForm(props) {
  const history = useHistory();
  const session = useContext(SessionContext);

  const [allData, setAllData] = useState([]);
  const [suppressInvoiceData, setSuppressInvoiceData] = useState();
  const [invoiceCategoryData, setInvoiceCategoryData] = useState();
  const [loadingMessage, setLoadingMessage] = useState("No Invoice Category Found.")
  const [suppressedList, setSuppressedList] = useState(null);
  const [disableUpdateBtn, setDisableUpdateBtn] = useState(true);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);

  const getInvoiceSuppressionList = () => {
    session
    .query("admin/get_suppression_invoice_category", { id: invoiceCategoryData.id })
    .then((response) => {
      setSuppressedList(response);
    })
  }

  useEffect(() => {
    if (props.args.id) {
      setLoadingMessage("Loading...");
      session
      .query("admin/get_invoice_category_suppression", { id: props.args.id })
      .then((response) => {
        setAllData(response);
        setSuppressInvoiceData(response.suppressed_am_invoice_category);
        setInvoiceCategoryData(response.am_invoice_category);
        setLoadingMessage("No Invoice Category Found.");
      })
      .catch((error) => {
        console.log("Failed to Load Invoice Category", JSON.stringify(error));
        setLoadingMessage("Failed to Load Invoice Category.");
      });
    } else {
      setLoadingMessage("No Invoice Category Found.");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onClickBack() {
    history.push("/admin-suppress-invoice-category");
  }

  function onSelectNewSuppression(_id) {
    let new_selection = {};
    suppressedList.forEach((val) => {
      if(val.id.toString() === _id.toString()) {
        new_selection = {...val};
      }
    });
    setSuppressInvoiceData(new_selection);
  }

  function onClickUpdate() {
    let updatedData = {...allData, suppressed_am_invoice_category: suppressInvoiceData}
    session.command('admin/update_invoice_category_suppression', updatedData, {}, { defaultErrorHandling: false })
    .then(() => {
      setShowSuccess(true);
      setDisableUpdateBtn(true);
      setTimeout(() => {
        onClickBack();
      }, 2000);
    })
    .catch((err) => {
      if(err.includes("uniq_ic_s")) {
        setErrorModalOpen(true);
      }
      console.log("Suppressed Invoice Category Update Failed", err)
    })
  }

  useEffect(() => {
    if(allData && suppressInvoiceData) {
      if(suppressInvoiceData.id !== allData.suppressed_am_invoice_category.id) {
        setDisableUpdateBtn(false);
      } else {
        setDisableUpdateBtn(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suppressInvoiceData])

  useEffect(() => {
    if(invoiceCategoryData) {
      getInvoiceSuppressionList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceCategoryData])

  return (
    <div className="page admin-page suppress-categories-page">
      <div className="list-header sticky-page-header">
        <button className="new-button" onClick={onClickBack}>
          <i className="bi bi-chevron-left"></i> Back
        </button>
        <h1>Suppressed Invoice</h1>
        <i className="spacer" />
        <button className="new-button promote" disabled={disableUpdateBtn} onClick={onClickUpdate}>
          Update
        </button>
      </div>
      <div className="m-5 suppress-main">
        <div className="mx-3">
          <h5>Invoice Category</h5>
          <div className="card-border light-gray">
            {invoiceCategoryData ? (<>
              <div className="my-1">Name: <strong>{invoiceCategoryData.name}</strong></div>
              <div className="my-1">Description: <strong>{invoiceCategoryData.description}</strong></div>
              <div className="my-1">Unit Price: <strong>{invoiceCategoryData.unit_price}</strong></div>
              <div className="my-1">Channel Options: <DisplayChannelOptions _list={invoiceCategoryData.channel_options} /></div>
            </>) : <div>{loadingMessage}</div>
            }
          </div>
        </div>

        <div className="mx-3">
          <h5>Suppressed Invoice Category</h5>
          <div className="card-border">
            {suppressInvoiceData ? (<>
              <div className="my-1">Name: <strong>{suppressInvoiceData.name}</strong></div>
              <div className="my-1">Description: <strong>{suppressInvoiceData.description}</strong></div>
              <div className="my-1">Unit Price: <strong>{suppressInvoiceData.unit_price}</strong></div>
              <div className="my-1">Channel Options: <DisplayChannelOptions _list={suppressInvoiceData.channel_options} /></div>
            </>) : <div>{loadingMessage}</div>
            }
          </div>
        </div>
      </div>
      <div className="m-5 suppress-main">
        <div className="mx-3">
          <h5>Select New Suppressed Invoice Category</h5>
          {suppressedList ? <select defaultValue="" onChange={(e) => onSelectNewSuppression(e.target.value)}>
            <option value="" disabled >Select a new value</option>
            {suppressedList.map((option) => (
              <option key={option.id} value={option.id}>
                {`${option.name} - ${option.description}: $(${option.unit_price})`}
              </option>
            ))}
          </select> : <div>No Options Found</div>}
        </div>
      </div>
      <ConfirmSuccess show={showSuccess} label="Suppressed Invoice Updated." />
      <UnsavedChanges hasUnsavedChanges={!disableUpdateBtn} />
      <Modal
        isOpen={errorModalOpen}
      >
        <ModalHeader>
          Could Not Update
        </ModalHeader>
        <ModalBody>
          <p className="my-5">A Suppressed Invoice with these settings already exist.</p>
        </ModalBody>
        <ModalFooter>
          <button onClick={() => setErrorModalOpen(false)}>Close</button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default SuppressInvoiceForm;
